export default {
      id: "pattern-player-video-usage",
      viewBox: "0 0 90 63",
      url: "../icon/" + "icons.svg#pattern-player-video-usage",
      toString: function () {
        return this.url;
      }
    }